'use client';

import { c as _c } from "react/compiler-runtime";
import { translateInline } from '@/globals/translate/translateInline';
import { select } from '@/uiComposites/form/select.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { placement } from '@/uiPrimitives/layout/placement.css';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { objectKeys } from 'tsafe';
import { useSearchParams } from 'next/navigation';
import { useDOPRouter } from '@/globals/routing/DOPRouter';
import { ContactSectors } from './ContactBySector';
export const ContactBySectorSelector = t0 => {
  const $ = _c(21);
  const {
    sectors,
    headingSlug
  } = t0;
  const sectorSlugs = objectKeys(sectors);
  const router = useDOPRouter();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("sector");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sector = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classes(select, placement({
      alignSelf: "start"
    }));
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = sector || "";
  const t4 = "sector-select";
  const t5 = "sector-select-intro";
  let t6;
  if ($[3] !== headingSlug || $[4] !== router || $[5] !== searchParams) {
    t6 = event => {
      const sector_0 = event.target.value;
      if (sector_0 === "") {
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.delete("sector");
        router.replaceClient(`?${newSearchParams.toString()}`);
        return;
      }
      const newSearchParams_0 = new URLSearchParams(searchParams);
      newSearchParams_0.set("sector", sector_0);
      router.replaceClient(`?${newSearchParams_0.toString()}#${headingSlug}`);
    };
    $[3] = headingSlug;
    $[4] = router;
    $[5] = searchParams;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = addTestSelector("uiSectorSelector");
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <option value="">{translateInline({
        en: "Select your sector",
        nl: "Kies uw sector"
      })}</option>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== sectors) {
    t9 = (sectorSlug, index) => <option key={index} value={sectorSlug}>{sectors[sectorSlug].title}</option>;
    $[9] = sectors;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = sectorSlugs.map(t9);
  let t11;
  if ($[11] !== t10 || $[12] !== t2 || $[13] !== t3 || $[14] !== t6 || $[15] !== t7 || $[16] !== t8) {
    t11 = <select className={t2} value={t3} id={t4} aria-labelledby={t5} onChange={t6} {...t7}>{t8}{t10}</select>;
    $[11] = t10;
    $[12] = t2;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const t12 = sector != null && sectors[sector]?.content;
  let t13;
  if ($[18] !== t11 || $[19] !== t12) {
    t13 = <>{t11}{t12}</>;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
};